import { ChevronsDownUp, ChevronsUpDown } from "lucide-react";
import { Button } from "@/components/ui/Button";

interface Props {
  onExpandAll: () => void;
  onCollapseAll: () => void;
}

// Expand all / Collapse all for the all-markets Inventory page, sized like
// the toolbar's dropdowns.
export default function FoldAllButtons({ onExpandAll, onCollapseAll }: Props) {
  return (
    <>
      <Button type="button" variant="outline" size="sm" className="h-8 gap-1.5 px-3 text-xs font-normal" onClick={onExpandAll}>
        <ChevronsUpDown className="size-3.5" aria-hidden />
        Expand all
      </Button>
      <Button type="button" variant="outline" size="sm" className="h-8 gap-1.5 px-3 text-xs font-normal" onClick={onCollapseAll}>
        <ChevronsDownUp className="size-3.5" aria-hidden />
        Collapse all
      </Button>
    </>
  );
}
